import './scss/critique.scss';

import smoothscroll from '../node_modules/smoothscroll-polyfill';
smoothscroll.polyfill();


import './navbarOutline';
import './faq'
import './liste_adherents'
import './article'
import './palmares'
import './parallaxScroll.js';

/* 
import './navbarScroll.js';

import './panier.js';
import './concerts.js';
import './videopagine.js';
import './photos.js' */



$(".collapse").on('show.bs.collapse', function () {
   document.querySelector("nav").classList.add('navbar-open')
   document.querySelector("main").style.display = "none"
   document.querySelector("footer").style.display = "none"
});
$(".collapse").on('shown.bs.collapse', function () {
   // alert('The collapsible content is now fully shown.');
});
$(".collapse").on('hide.bs.collapse', function () {
   document.querySelector("nav").classList.remove('navbar-open')
   //  alert('The collapsible content is about to be hidden.');
});
$(".collapse").on('hidden.bs.collapse', function () {
   // alert('The collapsible content is now hidden.');
   document.querySelector("main").style.display = "block"
   document.querySelector("footer").style.display = "block"
});


